import React from 'react';

import { Title } from '@mantine/core';
import InfoCard from 'components/InfoCard';
import InfoCardSection from 'components/InfoCard/InfoCardSection';
import useCommittedClubProgram from 'hooks/committedClub/useCommittedClubProgram';
import { DEFAULT_PROGRAM_NAME } from 'utils/checkInProgram';

import PermissionContent from './PermissionContent';

interface ICheckInProgramPermissionSectionProps {
  checkedPermissions?: string[];
  disabled?: boolean;
}

const CheckInProgramPermissionSection = ({
  checkedPermissions,
  disabled = false,
}: ICheckInProgramPermissionSectionProps): JSX.Element => {
  const { data } = useCommittedClubProgram();
  const programName = data?.data.results?.[0]?.name || DEFAULT_PROGRAM_NAME;

  return (
    <InfoCard
      header={<Title order={4}>{programName}</Title>}
      actionButton={<></>}
      content={
        <InfoCardSection
          content={
            <PermissionContent
              permissions={[
                {
                  title: 'View results and download reports',
                  permission: 'CheckInProgramView',
                  defaultCheckedOffBy: ['CheckInProgramManage'],
                },
                {
                  title: `Configure ${programName} settings`,
                  permission: 'CheckInProgramManage',
                },
              ]}
              checkedPermissions={checkedPermissions}
              disabled={disabled}
            />
          }
        />
      }
    />
  );
};

export default CheckInProgramPermissionSection;
